import {
    Locale,
    GameName,
    gameSettings,
    DefaultLocale,
} from "inbox-contentful";

const gameName: GameName = "boombeach";

export const config = {
    gameName,
    gameResolution: {
        x: 455,
        y: 285,
    },
    locales: (gameSettings[gameName]?.enabledLocales ?? [
        DefaultLocale,
    ]) as Locale[],
    tabs: ["news", "community", "community/megacrab"],
    isFullScreen: false,
};
